import { DataModel, YesNoEnum } from '@shared';
import { LoggingService } from '@shared/logging';
import { RxCollectionCreator } from 'rxdb';
import { WorkspaceDatabaseKeys } from '../../schemas/workspace-database-keys';
import { MigrationSchemaBuilder } from '../migration-schema.builder';
import { MigrationStep } from '../migration-step.interface';

export class MigrationV3 extends MigrationStep {
	public version = 3;

	public constructor(protected loggingService: LoggingService) {
		super(loggingService);
	}

	public applyMigrationOnSchema(collectionToMigrate: RxCollectionCreator): RxCollectionCreator {
		if (!collectionToMigrate) {
			this.loggingService.error(
				'MigrationV3',
				'Please provide the collection  on which you want to apply the migration'
			);
			throw new Error('Please provide the collection on which you want to apply the migration');
		}

		if (!collectionToMigrate.migrationStrategies) {
			collectionToMigrate.migrationStrategies = {};
		}

		collectionToMigrate.migrationStrategies[this.version] = (oldDoc: DataModel) => {
			const newDoc = { ...oldDoc };
			newDoc.is_master = YesNoEnum.Yes.toString();

			return newDoc;
		};

		if (this.shouldSkipMigration(collectionToMigrate.schema.version)) {
			if (this.hasNext()) {
				return this.getNext().applyMigrationOnSchema(collectionToMigrate);
			} else {
				return collectionToMigrate;
			}
		}

		const migratedSchema = new MigrationSchemaBuilder(collectionToMigrate.schema)
			.setSchemaVersion(this.version)
			.addNewProperty(WorkspaceDatabaseKeys.columns.isMaster, 'string')
			.build();

		this.loggingService.info(
			'MigrationV3.applyMigrationOnSchema, migratedSchema version: ',
			JSON.stringify(migratedSchema.version)
		);

		collectionToMigrate = { ...collectionToMigrate, schema: migratedSchema, autoMigrate: false };

		if (this.hasNext()) {
			return this.getNext().applyMigrationOnSchema(collectionToMigrate);
		}

		return collectionToMigrate;
	}
}
